/**
 * Тексты подсказки «Как это работает» для каждого сервиса. Показываются
 * новичку один раз на странице сервиса, потом доступны по ссылке (см.
 * components/HowItWorks.tsx). Тексты согласованы с владельцем 2026-09-08.
 */

import { pluralCredits } from '@masha/shared';

export type ServiceKey = 'reels' | 'carousel' | 'uniq';

export interface HowItWorksCopy {
  steps: string[];
  note: string;
}

export const HOW_IT_WORKS: Record<ServiceKey, HowItWorksCopy> = {
  reels: {
    steps: [
      'Выбери идею из библиотеки',
      'Ответь на 8 вопросов о себе и продукте, можно голосом',
      'Через минуту получи сценарий: заголовок, раскадровку и текст под видео',
    ],
    note: 'Цена сценария — по текущим настройкам, первая переделка бесплатно.',
  },
  carousel: {
    steps: [
      'Выбери, на чём построить историю: кейс, ошибка, эксперимент',
      'Ответь на 8 вопросов и выбери стиль оформления',
      'Получи слайды картинками в приложении и файлами в Telegram',
    ],
    note: 'Цена карусели — по текущим настройкам, смена стиля бесплатна.',
  },
  uniq: {
    steps: [
      'Загрузи один ролик до 90 секунд',
      'Получи 5 копий: для зрителя одинаковые, для алгоритмов разные',
      'Выкладывай копии на разные аккаунты',
    ],
    note: 'Копии хранятся сутки.',
  },
};

/** Duplicator note with the current price (settings.cost_uniq). */
export function uniqNote(costCredits: number | null): string {
  if (costCredits === null) return HOW_IT_WORKS.uniq.note;
  if (costCredits === 0) return 'Бесплатно, копии хранятся сутки.';
  return `Один ролик стоит ${costCredits} ${pluralCredits(costCredits)}, копии хранятся сутки.`;
}

/** Reels note with the current price (settings.cost_reels). */
export function reelsNote(cost: number): string {
  if (cost === 0) return 'Сценарий бесплатно, первая переделка тоже.';
  return `Один сценарий стоит ${cost} ${pluralCredits(cost)}, первая переделка бесплатно.`;
}

/** Carousel note with the current price (settings.cost_carousel). */
export function carouselNote(cost: number): string {
  if (cost === 0) return 'Карусель бесплатно, смена стиля тоже.';
  return `Одна карусель стоит ${cost} ${pluralCredits(cost)}, смена стиля бесплатна.`;
}
